import { gql } from '@apollo/client'

const DELETE_FAKE_MENU_MUTATION = gql`
  mutation deleteFakeMenuMutation($id: ID!) {
    deleteFakeMenu(id: $id)
  }
`

export default DELETE_FAKE_MENU_MUTATION
